const grays = {
  abbey: "#555757",
  alto: "#DFDFDF",
  boulder: "#757575",
  capeCod: "#323535",
  codGray: "#121212",
  diesel: "#030001",
  dustyGray: "#999999",
  gallery: "#EEEEEE",
  gray: "#858585",
  mercury: "#E6E6E6",
  mineShaft: "#333333",
  nevada: "#6D6E71",
  quillGray: "#D3D3D2",
  shark: "#191A1C",
  silver: "#CCCCCC",
  silverChalice: "#A6A6A6",
  tundora: "#444444",
  wildSand: "#F6F6F6"
}

const greens = {
  atlantis: "#5ECA2D",
  greenYellow: "#72F536",
  lima: "#6EEC34",
  springGreen: "#36F585"
}

const reds = {
  pomegranate: "#F44336"
}

const yellows = {
  gorse: "#FFEA4F",
  schoolBusYellow: "#FFE002"
}

const colors = {
  ...grays,
  ...greens,
  ...reds,
  ...yellows,
  black: "#000000",
  white: "#FFFFFF"
}

export default colors
